import {
  http
} from '../../config';
import base from '../base';

export const payroll={
  getAgtPayroll(data){
    return http({
      url:`${base.users}/teacherProxy/queryTeacherPayrollList`,
      method:'post',
      data
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/agent-api/payroll.js